import queryStringBuilder, { QueryParams } from '../../../utils/queryStringBuilder'
import { PreReserveUrl } from './urls'
import { NavigateFunction } from 'react-router-dom'
import showResponseError from '../../../utils/showResponseError'
/* eslint-disable camelcase */
import {
  createSlice,
  PayloadAction,
  createAsyncThunk,
  ActionReducerMapBuilder,
} from '@reduxjs/toolkit'

import { AppHttpConfig as API } from '../../../services/httpConfig'

import toastify from '../../../utils/toastify'
import {
  DispatchStatus,
  IPreReserveInitialState,
  PilgrimPerReserveList,
  PreReserveList,
} from './types'
import { PaymentStatus, ToastType } from '../../../types/generalType'
import { t } from 'i18next'
import hasObjectData from '../../../utils/hasObjectData'
import { searchPilgrim } from '../pilgrim/pilgrimSlice'

const initialState: IPreReserveInitialState = {
  loading: false,
  preReserve: {
    loading: false,
    preReserveList: { total: 0, data: [], totalPilgrims: 0 },
    currentPage: 1,
  },
  undispatchPreReserve: {
    loading: false,
    preReserveList: { total: 0, data: [] },
    currentPage: 1,
  },
  pilgrimPreReserve: {
    loading: false,
    pilgrimPreReserveList: [],
  },
  canclePreReserve: {
    loading: false,
  },
  myPreReserves: {
    loading: false,
    myPreReserveList: {
      total: 0,
      data: [],
      totalPilgrims: 0,
    },
    currentPage: 1,
  },
  updateTourKindType: {
    loading: false,
  },
  deletePreReserve: {
    deletePreReserveLoading: false,
  },
  dispatchPreReserve: {
    dispatchPreReserveLoading: false,
  },
  updatePreReserveProvince: {
    updatePreReserveProvinceLoading: false,
  },
  paymentStatusType: null,
  tourKindType: null,
  martyrNumber: '',
  preReserveId: '',
  province:'',
  city:''
}

// get all preReserve
export const getAllPreReserve = createAsyncThunk<PreReserveList, QueryParams>(
  'preReserve/getAllPreReserve',
  async (data: QueryParams) => {
    const query = hasObjectData(data) ? queryStringBuilder(data) : ''
    try {
      const response = await API.get(`${PreReserveUrl.getAll}${query}`)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          }
          if (res.status === 204) {
            return res.data
          }
        })
        .catch((error) => {
          showResponseError(error)
        })
      return response
    } catch (error) {
      showResponseError(error)
    }
  },
)

// get all undispatch preReserve
export const getAllUndispatchPreReserve = createAsyncThunk<PreReserveList, QueryParams>(
  'preReserve/getAllUndispatchPreReserve',
  async (data: QueryParams) => {
    const query = hasObjectData(data) ? queryStringBuilder(data) : ''
    try {
      const response = await API.get(`${PreReserveUrl.getAll}${query}`)
        .then((res) => {
          if (res.status === 200) {
            const { data, total } = res.data
            const newData = data.filter(
              (item: any) =>
                item.dispatchStatus === DispatchStatus.UNDISPATCH &&
                item.preReservePaymentStatus === PaymentStatus.TemporaryPayment,
            )
            return { total, data: newData }
          }
          if (res.status === 204) {
            return res.data
          }
        })
        .catch((error) => {
          showResponseError(error)
        })
      return response
    } catch (error) {
      showResponseError(error)
    }
  },
)
// get preReserve by nationalCode
export const getPreReserveByNationalCode = createAsyncThunk<any, string>(
  'preReserve/getPreReserveByNationalCode',
  async (nationalCode: string) => {
    try {
      const response = await API.get(
        `${PreReserveUrl.getByNationalCode}?NationalCode=${nationalCode}`,
      )
        .then((res) => {
          if (res.status === 200) {
            return res.data
          }
          if (res.status === 204) {
            return res.data
          }
        })
        .catch((error) => {
          showResponseError(error)
        })
      return response
    } catch (error) {
      showResponseError(error)
    }
  },
)
// get preReserve by id
export const getPreReserveById = createAsyncThunk<PilgrimPerReserveList, string>(
  'preReserve/getPreReserveById',
  async (id: string) => {
    try {
      const response = await API.get(`${PreReserveUrl.getById}?id=${id}`)
        .then((res) => {
          if (res.status === 200) {
            return res.data
          }
        })
        .catch((error) => {
          showResponseError(error)
        })
      return response
    } catch (error) {
      showResponseError(error)
    }
  },
)

// Cancle preReserve
export const canclePreReserve = createAsyncThunk<
  any,
  { data: { id: string; iBan: string }; navigate: NavigateFunction }
>('preReserve/canclePreReserve', async (command) => {
  const { data, navigate } = command
  try {
    const response = await API.put(PreReserveUrl.CanclePreReserve, data)
      .then((res) => {
        if (res.status === 201) {
          navigate('/PreReserve/MyPreReserve')
          toastify(ToastType.SUCCESS, { operatin: t('cancle'), pageName: t('preReserve') })
          return res.data
        }
      })
      .catch((error) => {
        showResponseError(error)
      })
    return response
  } catch (error) {
    showResponseError(error)
  }
})

// update tour kind type
export const updateTourKindType = createAsyncThunk<
  number,
  { data: { preReserveId: string; transportationType: number }; id: string }
>('preReserve/updateTourKindType', async (command, { dispatch }) => {
  const { data, id } = command
  try {
    const response = await API.put(PreReserveUrl.UpdateTourKindType, data)
      .then((res) => {
        if (res.status === 201) {
          dispatch(getPreReserveById(id))
          return res.data
        }
      })
      .catch((error) => {
        showResponseError(error)
      })
    return response
  } catch (error) {
    showResponseError(error)
  }
})

// Delete preReserve
export const deletePreReserve = createAsyncThunk<any, { id: string; seatchQuery?: QueryParams }>(
  'preReserve/deletePreReserve',
  async (data, { dispatch }) => {
    const { id, seatchQuery } = data
    try {
      const response = await API.put(PreReserveUrl.DeletePreReserve, { id })
        .then((res) => {
          if (res.status === 201) {
            toastify(ToastType.ERROR, { operatin: t('delete'), pageName: t('preReserve') })
            dispatch(searchPilgrim(seatchQuery as QueryParams))
            return res.data
          }
        })
        .catch((error) => {
          showResponseError(error)
        })
      return response
    } catch (error) {
      showResponseError(error)
    }
  },
)

// Delete My Pre-Reserve
export const deleteMyPreReserve = createAsyncThunk<any, { id: string; nationalCode: string }>(
  'preReserve/deleteMyPreReserve',
  async (data, { dispatch }) => {
    const { id, nationalCode } = data
    try {
      const response = await API.put(PreReserveUrl.DeletePreReserve, { id })
        .then((res) => {
          if (res.status === 201) {
            toastify(ToastType.ERROR, { operatin: t('delete'), pageName: t('preReserve') })
            dispatch(getPreReserveByNationalCode(nationalCode))
            return res.data
          }
        })
        .catch((error) => {
          showResponseError(error)
        })
      return response
    } catch (error) {
      showResponseError(error)
    }
  },
)

// Dispatch Pre-Reserve
export const dispatchPreReserve = createAsyncThunk<
  any,
  { date: string; ids: string[]; navigate: NavigateFunction }
>('preReserve/dispatchPreReserve', async (data) => {
  const { date, ids, navigate } = data
  try {
    const response = await API.put(PreReserveUrl.DispatchPreReserve, { date, ids })
      .then((res) => {
        if (res.status === 201) {
          toastify(ToastType.SUCCESS, { operatin: t('save'), pageName: t('transferDate') })
          navigate('/')
          return res.data
        }
      })
      .catch((error) => {
        showResponseError(error)
      })
    return response
  } catch (error) {
    showResponseError(error)
  }
})

// update tour kind type
export const updatePreReserveProvince = createAsyncThunk<
  boolean,
  {
    preReserveId: string
    province: string
    city: string
    zone: number | string
  }
>('preReserve/updatePreReserveProvince', async (command, { dispatch }) => {
  try {
    const response = await API.put(PreReserveUrl.UpdatePreReserveProvince, command)
      .then((res) => {
        if (res.status === 201) {
          dispatch(clearPilgrimPreReserveList())
          dispatch(getPreReserveById(command.preReserveId))
          return res.data
        }
      })
      .catch((error) => {
        showResponseError(error)
      })
    return response
  } catch (error) {
    showResponseError(error)
  }
})

const preReserveSlice = createSlice({
  name: 'preReserve',
  initialState,
  reducers: {
    clearPilgrimPreReserveList: (state) => {
      state.pilgrimPreReserve.pilgrimPreReserveList = []
      state.martyrNumber = ''
      state.preReserveId = ''
      state.paymentStatusType = null
      state.tourKindType = null
    },
    clearPreReserveList: (state) => {
      state.preReserve.preReserveList = { total: 0, data: [], totalPilgrims: 0 }
    },

    setPreReserveDetaile: (
      state,
      action: PayloadAction<
        {
          tourKindType: number
          martyrNumber: string
          preReservePaymentStatus: PaymentStatus | string | null
          province:string
          city:string
        },
        string
      >,
    ) => {
      state.tourKindType = action.payload.tourKindType
      state.paymentStatusType = action.payload.preReservePaymentStatus
      state.martyrNumber = action.payload.martyrNumber
      state.province = action.payload.province
      state.city = action.payload.city
    },

    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.preReserve.currentPage = action.payload
    },
    setMyPreReserveCurrentPage: (state, action: PayloadAction<number>) => {
      state.myPreReserves.currentPage = action.payload
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<IPreReserveInitialState>) => {
    // get all
    builder
      .addCase(getAllPreReserve.pending, (state) => {
        state.preReserve.loading = true
      })
      .addCase(getAllPreReserve.fulfilled, (state, action: PayloadAction<PreReserveList, any>) => {
        state.preReserve.loading = false
        state.preReserve.preReserveList = action.payload
      })
      .addCase(getAllPreReserve.rejected, (state) => {
        state.preReserve.loading = false
        state.preReserve.preReserveList = { total: 0, data: [], totalPilgrims: 0 }
        state.martyrNumber = ''
        state.preReserveId = ''
        state.paymentStatusType = null
        state.tourKindType = null
      })
    // get all undispatch pre-reserve
    builder
      .addCase(getAllUndispatchPreReserve.pending, (state) => {
        state.undispatchPreReserve.loading = true
      })
      .addCase(
        getAllUndispatchPreReserve.fulfilled,
        (state, action: PayloadAction<Omit<PreReserveList, 'totalPilgrims'>, any>) => {
          state.undispatchPreReserve.loading = false
          state.undispatchPreReserve.preReserveList = action.payload
        },
      )
      .addCase(getAllUndispatchPreReserve.rejected, (state) => {
        state.undispatchPreReserve.loading = false
        state.undispatchPreReserve.preReserveList = { total: 0, data: [] }
        state.martyrNumber = ''
        state.preReserveId = ''
        state.paymentStatusType = null
        state.tourKindType = null
      })
    // get preReserve by nationalcode
    builder
      .addCase(getPreReserveByNationalCode.pending, (state) => {
        state.myPreReserves.loading = true
      })
      .addCase(getPreReserveByNationalCode.fulfilled, (state, action: PayloadAction<any>) => {
        state.myPreReserves.loading = false
        state.myPreReserves.myPreReserveList = action.payload
        state.preReserveId = action.payload.id
        state.martyrNumber = action.payload.martyrNumber
        state.paymentStatusType = action.payload.preReservePaymentStatus
        state.tourKindType = action.payload.tourKindTypeText
      })
      .addCase(getPreReserveByNationalCode.rejected, (state) => {
        state.myPreReserves.loading = false
        state.myPreReserves.myPreReserveList = { total: 0, data: [], totalPilgrims: 0 }
        state.martyrNumber = ''
        state.preReserveId = ''
        state.paymentStatusType = null
      })

    // get preReserve by id
    builder
      .addCase(getPreReserveById.pending, (state) => {
        state.pilgrimPreReserve.loading = true
      })
      .addCase(
        getPreReserveById.fulfilled,
        (state, action: PayloadAction<PilgrimPerReserveList>) => {
          state.pilgrimPreReserve.loading = false
          state.pilgrimPreReserve.pilgrimPreReserveList = action.payload
          state.martyrNumber = action.payload[0]['martyrNumber']
          state.paymentStatusType = action.payload[0]['preReservePaymentStatus']
          state.tourKindType = action.payload[0]['tourKindType']
        },
      )
      .addCase(getPreReserveById.rejected, (state) => {
        state.pilgrimPreReserve.loading = false
        state.pilgrimPreReserve.pilgrimPreReserveList = []
      })
    // Cancle Pre-Reserve
    builder
      .addCase(canclePreReserve.pending, (state) => {
        state.canclePreReserve.loading = true
      })
      .addCase(canclePreReserve.fulfilled, (state) => {
        state.canclePreReserve.loading = false
      })
      .addCase(canclePreReserve.rejected, (state) => {
        state.canclePreReserve.loading = false
      })

    // Update Tour Kind Type
    builder
      .addCase(updateTourKindType.pending, (state) => {
        state.updateTourKindType.loading = true
      })
      .addCase(updateTourKindType.fulfilled, (state) => {
        state.updateTourKindType.loading = false
      })
      .addCase(updateTourKindType.rejected, (state) => {
        state.updateTourKindType.loading = false
      })
    // Delete Pre-Reserve
    builder
      .addCase(deletePreReserve.pending, (state) => {
        state.deletePreReserve.deletePreReserveLoading = true
      })
      .addCase(deletePreReserve.fulfilled, (state) => {
        state.deletePreReserve.deletePreReserveLoading = false
      })
      .addCase(deletePreReserve.rejected, (state) => {
        state.deletePreReserve.deletePreReserveLoading = false
      })
    // Delete My Pre-Reserve
    builder
      .addCase(deleteMyPreReserve.pending, (state) => {
        state.deletePreReserve.deletePreReserveLoading = true
      })
      .addCase(deleteMyPreReserve.fulfilled, (state) => {
        state.deletePreReserve.deletePreReserveLoading = false
      })
      .addCase(deleteMyPreReserve.rejected, (state) => {
        state.deletePreReserve.deletePreReserveLoading = false
      })
    // Dispatch Pre-Reserve
    builder
      .addCase(dispatchPreReserve.pending, (state) => {
        state.dispatchPreReserve.dispatchPreReserveLoading = true
      })
      .addCase(dispatchPreReserve.fulfilled, (state) => {
        state.dispatchPreReserve.dispatchPreReserveLoading = false
      })
      .addCase(dispatchPreReserve.rejected, (state) => {
        state.dispatchPreReserve.dispatchPreReserveLoading = false
      })

    // Update PreReserve Province
    builder
      .addCase(updatePreReserveProvince.pending, (state) => {
        state.updatePreReserveProvince.updatePreReserveProvinceLoading = true
      })
      .addCase(updatePreReserveProvince.fulfilled, (state) => {
        state.updatePreReserveProvince.updatePreReserveProvinceLoading = false
      })
      .addCase(updatePreReserveProvince.rejected, (state) => {
        state.updatePreReserveProvince.updatePreReserveProvinceLoading = false
      })
  },
})

export const {
  clearPilgrimPreReserveList,
  clearPreReserveList,
  setPreReserveDetaile,
  setCurrentPage,
  setMyPreReserveCurrentPage,
} = preReserveSlice.actions

export default preReserveSlice.reducer
